'use strict';
import {createEventHandler, mapPropsStream} from 'recompose';
import 'rxjs/add/operator/combineLatest';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/takeUntil';
import {ScaleFieldEditView} from './ScaleFieldEditView';


export const StreamedComponent = (props$) => {
  const {
    handler: onChange,
    stream: fieldChange$,
  } = createEventHandler();

  fieldChange$
    .withLatestFrom(props$)
    .takeUntil(props$.last())
    .subscribe(([val, props]) => {
      const options = props.field.options;
      props.onChange([props.field.id, {
        target: {
          value: options.range ? {
            value: val[0],
            high: val[1],
          } : {
            value: val[0],
          },
        },
      }]);
    });

  const range$ = props$
  // TODO: there are edge cases where we need to check that options.range has changed too.
    .distinctUntilChanged(null, props => props.value)
    .map(props => {
      const options = props.field.options;
      const result = props.value;

      if (options.range) {
        return [result.value, result.high];
      } else {
        return [result.value];
      }
    });

  return props$
    .combineLatest(
      range$,
      (props, range) => ({
        ...props,
        range,
        onChange,
      }));
};

export const ScaleFieldEditComponent = mapPropsStream(StreamedComponent)(ScaleFieldEditView);



// WEBPACK FOOTER //
// ./src/js/form-builder/components/response/fields/ScaleFieldEdit/ScaleFieldEditComponent.js